export default __webpack_public_path__ + "static/sheenRight-80019027657d51f0dbe8dbc450777cdb.png";